import React from "react";
import styled from "styled-components";

const TabBarWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  background-color: var(--tab-bar-bg);
  color: var(--main-font-color);
  padding: 5px;
  border-radius: 5px;
`;

const Tab = styled.div`
  font-size: 16px;
  font-weight: 500;
  width: 50%;
  cursor: pointer;
  border-radius: 5px;
  text-align: center;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;

  &.selected {
    background-color: var(--sidebar-active-item-bg);
    color: var(--sidebar-active-item-color);
  }
`;

export const TabBar = ({
  tabs,
  counts = [],
  hideTabs = [],
  selectedTab = "",
  onSelect = () => { },
}) => {
  return (
    <TabBarWrapper>
      {tabs.filter(tab => !hideTabs.includes(tab)).map((tab) => (
        <Tab
          key={tab}
          className={selectedTab === tab ? "selected" : ""}
          onClick={() => onSelect(tab)}
        >
          {tab}
          {counts.length > 0 && counts[tabs.indexOf(tab)] !== undefined ? (
            <span
              style={{
                marginLeft: "5px",
                fontSize: "14px",
                fontWeight: 900,
              }}
            >
              {counts[tabs.indexOf(tab)] !== null
                ? `(${counts[tabs.indexOf(tab)]})`
                : ""}
            </span>
          ) : null}
        </Tab>
      ))}
    </TabBarWrapper>
  );
};

export default TabBar;
